import type { MapDefinition, RackDefinition, RackSettings } from "./types";

export function findRackSettings(settings: readonly RackSettings[], rackId: string): RackSettings | undefined {
    return settings.find((item) => item.rackId === rackId);
}

export function applyRackSettingsToMap(map: MapDefinition, settings: readonly RackSettings[]): MapDefinition {
    const settingsByRackId = new Map(settings.map((item) => [item.rackId, item]));
    let changed = false;
    const racks = map.racks.map((rack) => {
        const sizeU = settingsByRackId.get(rack.id)?.sizeU;
        if (sizeU === undefined || sizeU === rack.sizeU) {
            return rack;
        }
        changed = true;
        return { ...rack, sizeU };
    });
    return changed ? { ...map, racks } : map;
}

export function isRackSizeConfigurable(rack: RackDefinition, settings: RackSettings | undefined): boolean {
    const sizeU = settings?.sizeU ?? rack.sizeU;
    return rack.type !== "wall-4u" && (sizeU === 24 || sizeU === 42) && settings?.sizeSource === undefined;
}

export function getRackDisplayName(
    rack: RackDefinition,
    settings: readonly RackSettings[],
    officialName: string,
): string {
    const customName = findRackSettings(settings, rack.id)?.name;
    return customName === undefined ? officialName : customName;
}

export function getPlacementLocalDisplayName(
    localName: string | undefined,
    rackName: string,
    showRackNameAsPrefix: boolean,
): string | undefined {
    if (localName === undefined) {
        return undefined;
    }
    return showRackNameAsPrefix ? `${rackName} · ${localName}` : localName;
}
